import { render } from "./MyStages.vue?vue&type=template&id=a1b57994&scoped=true"
import script from "./MyStages.vue?vue&type=script&lang=js"
export * from "./MyStages.vue?vue&type=script&lang=js"

import "./MyStages.vue?vue&type=style&index=0&id=a1b57994&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1b57994"]])

export default __exports__